import React from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Instrument_Check_Form.css";

function Instrument_Check_Form({ onProceed }) {
  const instrumentOptions = [
    { value: "ika", label: "Ika Bomb Calorimeter" },
  ];

  const checkByOptions = [
    { value: "rahul", label: "Rahul Mali" },
    { value: "amit", label: "Amit Verma" },
  ];

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">

          {/* Instrument */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Instrument</Form.Label>
              <Select
                options={instrumentOptions}
                placeholder="Select Instrument"
                classNamePrefix="react_select"
              />
            </Form.Group>
          </div>

          {/* Instrument ID */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Instrument ID</Form.Label>
              <Form.Control placeholder="Instrument ID" />
            </Form.Group>
          </div>

          {/* Check By */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Check By</Form.Label>
              <Select
                options={checkByOptions}
                placeholder="Select who Check By"
                classNamePrefix="react_select"
              />
            </Form.Group>
          </div>

          {/* Break Down */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Break Down</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control placeholder="From : DD/MM/YYYY" />
                <Form.Control placeholder="To : DD/MM/YYYY" />
              </div>
            </Form.Group>
          </div>

          {/* Next Due On */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Next Due On</Form.Label>
              <Form.Control placeholder="DD/MM/YYYY" />
            </Form.Group>
          </div>

        </div>

        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn">Cancel</Button>
          <Button className="permission_btn Yes_btn" onClick={onProceed}>
            Proceed
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Instrument_Check_Form;
